import React, { useState } from "react";
import { Edit } from "lucide-react";
import { Link } from "react-router-dom";
export default function Campaign() {
  const [campaigns, setCampaigns] = useState([
    {
      id: 1,
      name: "Holiday Promo",
      createdOn: "2025-10-01",
      plannedDate: "2025-12-01",
    },
    {
      id: 2,
      name: "Summer Sale",
      createdOn: "2025-08-15",
      plannedDate: "2025-09-01",
    },
  ]);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const handleCreateCampaign = () => {
    const newCampaign = {
      id: campaigns.length + 1,
      name: `Campaign ${campaigns.length + 1}`,
      createdOn: new Date().toLocaleDateString(),
      plannedDate: new Date(Date.now() + 86400000).toLocaleDateString(),
    };
    setCampaigns([...campaigns, newCampaign]);
  };
  const totalPages = Math.ceil(campaigns.length / itemsPerPage);
  const displayed = campaigns.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          Campaigns
        </h1>
        <button
          onClick={handleCreateCampaign}
          className="mt-2 sm:mt-0 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow"
        >
          + Create Campaign
        </button>
      </div>
      <p className="text-gray-600 mb-3">Learn more about email campaigns</p>
      {/* Table */}
      <div className="overflow-x-auto bg-white shadow rounded-lg">
        <table className="w-full text-sm text-gray-700">
          <thead className="bg-gray-100 text-gray-800">
            <tr>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-left">Created on</th>
              <th className="px-4 py-3 text-left">Planned date of sending</th>
              <th className="px-4 py-3 text-center">Edit</th>
            </tr>
          </thead>
          <tbody>
            {displayed.length > 0 ? (
              displayed.map((campaign) => (
                <tr key={campaign.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3">{campaign.name}</td>
                  <td className="px-4 py-3">{campaign.createdOn}</td>
                  <td className="px-4 py-3">{campaign.plannedDate}</td>
                  <td className="px-4 py-3 text-center">
                    <Link
                      to={`/campaigns/${campaign.id}/edit`}
                      className="text-blue-600 hover:text-blue-800 inline-flex items-center gap-1"
                    >
                      <Edit size={18} />
                      Edit
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-6 text-center text-gray-500 italic"
                >
                  No data available in table
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-sm text-gray-700">
        <div className="flex items-center gap-2 mb-2 sm:mb-0">
          <span>Show</span>
          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="border rounded px-2 py-1"
          >
            {[5, 10, 15, 20].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
          <span>items</span>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handlePrevious}
            disabled={currentPage === 1}
            className={`px-3 py-1 rounded ${
              currentPage === 1
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages || totalPages === 0}
            className={`px-3 py-1 rounded ${
              currentPage === totalPages || totalPages === 0
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
